const getFeatures = state => ({ ...state.featureToggles });

export default getFeatures;
